const row_contextmenu_dialog = {
  namespaced: true,
  state: {
    type:'row',
    isShow:false,
    top:-300,
    left:-300,
    contextmenu_obj:null,//通栏数据临时储存
    contextmenu_module:null,//挂件数据临时储存
  },
  mutations: {
    SET_isShow(state, val) {
      state.isShow = val;
    },
    SET_top(state, val) {
      state.top = val;
    },
    SET_left(state, val) {
      state.left = val;
    },
    SET_contextmenu_obj(state, val) {
      state.contextmenu_obj = val;
    },
    SET_type(state, val) {
      state.type = val;
    },
    SET_contextmenu_module(state, val) {
      state.contextmenu_module = val;
    },

  },
  actions: {


  }

};


export default row_contextmenu_dialog;



// WEBPACK FOOTER //
// ./src/vuex/modules/row_contextmenu_dialog.js